module.exports = __webpack_public_path__ + "10fb79ed7421b58785d7f5e5c287cc14.png";